import { FeedCurveInfo } from "../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedCurvesCall";
import { AnimalGroupData, Group } from "./animalGroups";
import { Condition } from "./conditions";
import { LocationData, Location } from "./locations";
import { TestData as FeedCurveId } from "./feedCurvesData";
import { Milestone, Default_Milestones } from "./milestones";

  export enum AnimalTypes {
    Duroc = "Duroc",
    Yorkshire = "Yorkshire"
  }

  export enum CalendarNoteKeys {
    parity = "Parity",
    boar = "Boar",
    performer = "Performer",
    expFarrowing = "Exp. Farrowing",
    expWeaning = "Exp. Weaning",
    result = "Result"
  }

  export type CalendarNoteType = {
    [CalendarNoteKeys.parity]?: number
    [CalendarNoteKeys.boar]?: string
    [CalendarNoteKeys.performer]?: string
    [CalendarNoteKeys.expFarrowing]?: Date
    [CalendarNoteKeys.expWeaning]?: Date
    [CalendarNoteKeys.result]?: string
  }

export type CalendarEventNote = {
  [key in keyof CalendarNoteType]?: string | number | Date;
};

  export type AnimalCalendarEvent = {
    eventNo: number
    eventName: string
    date: Date
    note?: CalendarEventNote[]
  }

  export type Animals = {
    animalId: number;
    pen?: number;
    responderNo: number;
    lifeNo: number;
    lastDetected?: number;
    remainingToday?: number;
    remainingYesterday?: number;
    totalFood?: number; // & Partial<Pick<FeedCurveInfo, "id, totalFood">> ?
    feedPlan?: FeedCurveInfo['id']; //& Partial<Pick<FeedCurveInfo, "id">> 
    animalType?: AnimalTypes;
    milestoneDay?: Date;
    cycleDayTotal?: number;
    feedCorrection?: number;
    birthDate?: Date
    calendar?: AnimalCalendarEvent[]
  } & Partial<Pick<Milestone, "milestoneId">> 
  & Partial<Pick<Location, "locationId">> 
  & Partial<Pick<Condition, "conditionId">> 
  & Partial<Pick<Group, "groupId">>

  export const TestData: Animals[] = [
    { 
      animalId: 1236,
      responderNo: 984000003224226, 
      lifeNo: 5581019239, 
      lastDetected: 3, 
      remainingToday: 1, 
      remainingYesterday: 1, 
      totalFood: 6, 
      locationId: 1,
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 2,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 2,
      milestoneDay: new Date('2025-01-26'),
      cycleDayTotal: 50,
      birthDate: new Date('02-02-2023'),
      calendar: [
        {eventNo: 1, eventName: "Farrowing", date: new Date('06-24-2024'), note: [{Parity: 3}] },
        {eventNo: 2, eventName: "Weaning", date: new Date('09-16-2024') },
        {eventNo: 3, eventName: "Insemination", date: new Date('10-12-2024'), note: [{Boar: "0983"}, {Performer: "CG"}, {"Exp. Farrowing": new Date('09-14-2024')}, {"Exp. Weaning": new Date('10-12-2024')}] },
        {eventNo: 4, eventName: "Pregnancy Check", date: new Date('10-01-2025'), note: [{Result: "Pregnant", Performer: "CG"}] },
        // {eventNo: 5, eventName: "Farrowing", date: new Date('06-25-2024'), note: [{Parity: 3}] },
        // {eventNo: 6, eventName: "Farrowing", date: new Date('06-26-2024'), note: [{Parity: 3}] },
        // {eventNo: 7, eventName: "Farrowing", date: new Date('06-27-2024'), note: [{Parity: 3}] },
        // {eventNo: 8, eventName: "Farrowing", date: new Date('06-28-2024'), note: [{Parity: 3}] },
        // {eventNo: 9, eventName: "Farrowing", date: new Date('06-29-2024'), note: [{Parity: 3}] },
        // {eventNo: 10, eventName: "Farrowing", date: new Date('06-30-2024'), note: [{Parity: 3}] },
        // {eventNo: 11, eventName: "Farrowing", date: new Date('07-01-2024'), note: [{Parity: 3}] },
        // {eventNo: 12, eventName: "Farrowing", date: new Date('07-02-2024'), note: [{Parity: 3}] },
        // {eventNo: 13, eventName: "Farrowing", date: new Date('07-03-2024'), note: [{Parity: 3}] },
        // {eventNo: 14, eventName: "Farrowing", date: new Date('07-04-2024'), note: [{Parity: 3}] },
        // {eventNo: 15, eventName: "Farrowing", date: new Date('07-05-2024'), note: [{Parity: 3}] },
        // {eventNo: 16, eventName: "Farrowing", date: new Date('07-06-2024'), note: [{Parity: 3}] },
        // {eventNo: 17, eventName: "Farrowing", date: new Date('07-07-2024'), note: [{Parity: 3}] },
        // {eventNo: 18, eventName: "Farrowing", date: new Date('07-08-2024'), note: [{Parity: 3}] },
      ]
    },
    { 
      animalId: 2347, 
      // pen: 302, 
      responderNo: 984000003224227, 
      lifeNo: 5581019240, 
      lastDetected: 2, 
      locationId: 1,
      remainingToday: 2, 
      remainingYesterday: 5, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 2,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 1, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50,
      feedCorrection: 20
    },      
    { 
      animalId: 3458, 
      // pen: 303, 
      responderNo: 984000003224228, 
      lifeNo: 5581019241, 
      lastDetected: 4, 
      locationId: 1,
      remainingToday: 3.7, 
      remainingYesterday: 2.5, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 1, 
      animalType: AnimalTypes.Duroc, 
      milestoneId: 2, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50, 
      feedCorrection: -10
    },
    { 
      animalId: 4569, 
      // pen: 304, 
      responderNo: 984000003224230, 
      lifeNo: 5581019242, 
      lastDetected: 1, 
      locationId: 1,
      remainingToday: 4, 
      remainingYesterday: 5, 
      totalFood: 5, 
      conditionId: 4, 
      feedPlan: 1, 
      groupId: 1, 
      animalType: AnimalTypes.Duroc, 
      milestoneId: 2, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50,
      feedCorrection: 15
    },
    { 
      animalId: 5670, 
      // pen: 305, 
      responderNo: 984000003224230, 
      lifeNo: 5581019243, 
      lastDetected: 5, 
      locationId: 1,
      remainingToday: 2.5, 
      remainingYesterday: 5, 
      totalFood: 5, 
      conditionId: 5, 
      feedPlan: 2,
      groupId: 1, 
      animalType: AnimalTypes.Duroc, 
      milestoneId: 5, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 6781, 
      pen: 306, 
      responderNo: 984000003224231, 
      lifeNo: 5581019244, 
      lastDetected: 7, 
      locationId: 2,
      remainingToday: 1, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 1, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50
    },
    { 
      animalId: 7892, 
      pen: 307, 
      responderNo: 984000003224232, 
      lifeNo: 5581019245, 
      lastDetected: 8, 
      locationId: 1,
      remainingToday: 2, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 2, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 8903, 
      pen: 308, 
      responderNo: 984000003224233, 
      lifeNo: 5581019246, 
      lastDetected: 9, 
      locationId: 1,
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 1, 
      animalType: AnimalTypes.Duroc, 
      milestoneId: 3, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 9014, 
      pen: 309, 
      responderNo: 984000003224234, 
      lifeNo: 5581019247, 
      lastDetected: 2, 
      locationId: 1,
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 4, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 1124, 
      pen: 310, 
      responderNo: 984000003224235, 
      lifeNo: 5581019248, 
      lastDetected: 4, 
      locationId: 1,
      remainingToday: 2, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 5, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 2235, 
      pen: 311, 
      responderNo: 984000003224236, 
      lifeNo: 5581019249, 
      lastDetected: 1, 
      locationId: 1,
      remainingToday: 4, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 1, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 3346, 
      pen: 312, 
      responderNo: 984000003224237, 
      lifeNo: 5581019250, 
      lastDetected: 3, 
      locationId: 1,
      remainingToday: 4, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 2, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 4457, 
      pen: 313, 
      responderNo: 984000003224238, 
      lifeNo: 5581019251, 
      lastDetected: 6, 
      locationId: 1,
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 1, 
      animalType: AnimalTypes.Duroc, 
      milestoneId: 3, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 5568, 
      pen: 314, 
      responderNo: 984000003224239, 
      lifeNo: 5581019252, 
      lastDetected: 5, 
      locationId: 1,
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 1, 
      animalType: AnimalTypes.Duroc, 
      milestoneId: 4, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 6679, 
      pen: 315, 
      responderNo: 984000003224240, 
      lifeNo: 5581019253, 
      lastDetected: 8, 
      locationId: 1,
      remainingToday: 2, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 5, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 7780, 
      pen: 316, 
      responderNo: 984000003224241, 
      lifeNo: 5581019254, 
      lastDetected: 7, 
      locationId: 1,
      remainingToday: 1, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 1, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 8891, 
      pen: 317, 
      responderNo: 984000003224242, 
      lifeNo: 5581019255, 
      lastDetected: 4, 
      locationId: 1,
      remainingToday: 2, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 2, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 2, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 9902, 
      pen: 318, 
      responderNo: 984000003224243, 
      lifeNo: 5581019256, 
      lastDetected: 5, 
      locationId: 1,
      remainingToday: 4, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 3, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 1013, 
      pen: 319, 
      responderNo: 984000003224244, 
      lifeNo: 5581019257, 
      lastDetected: 6, 
      locationId: 1, 
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 4, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 4, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 2124, 
      pen: 320, 
      responderNo: 984000003224245, 
      lifeNo: 5581019258, 
      lastDetected: 7, 
      locationId: 1, 
      remainingToday: 2, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 5, 
      feedPlan: 2, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 5, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 3235, 
      pen: 321, 
      responderNo: 984000003224246, 
      lifeNo: 5581019259, 
      lastDetected: 8, 
      locationId: 1,
      remainingToday: 4, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 1, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 4346, 
      pen: 322, 
      responderNo: 984000003224247, 
      lifeNo: 5581019260, 
      lastDetected: 9, 
      locationId: 1,
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 2, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 2, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 5457, 
      pen: 323, 
      responderNo: 984000003224248, 
      lifeNo: 5581019261, 
      lastDetected: 1, 
      locationId: 1, 
      remainingToday: 2, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 3, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 6568, 
      pen: 324, 
      responderNo: 984000003224249, 
      lifeNo: 5581019262, 
      lastDetected: 2, 
      locationId: 1,
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 4, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 4, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 7679, 
      pen: 325, 
      responderNo: 984000003224250, 
      lifeNo: 5581019263, 
      lastDetected: 3, 
      locationId: 1,
      remainingToday: 4, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 5, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 8780, 
      pen: 326, 
      responderNo: 984000003224251, 
      lifeNo: 5581019264, 
      lastDetected: 4, 
      locationId: 1,
      remainingToday: 2, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 2, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 1, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 9891, 
      pen: 327, 
      responderNo: 984000003224252, 
      lifeNo: 5581019265, 
      lastDetected: 5, 
      locationId: 1,
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 2, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 1002, 
      pen: 328, 
      responderNo: 984000003224253, 
      lifeNo: 5581019266, 
      lastDetected: 6, 
      locationId: 1,
      remainingToday: 4, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 4, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 3, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 2113, 
      pen: 329, 
      responderNo: 984000003224254, 
      lifeNo: 5581019267, 
      lastDetected: 7, 
      locationId: 1,
      remainingToday: 2, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 4, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 3224, 
      pen: 330, 
      responderNo: 984000003224255, 
      lifeNo: 5581019268, 
      lastDetected: 8, 
      locationId: 1,
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 2, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 5, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 4335, 
      pen: 331, 
      responderNo: 984000003224256, 
      lifeNo: 5581019269, 
      lastDetected: 9, 
      locationId: 1,
      remainingToday: 4, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 1, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    { 
      animalId: 5446, 
      pen: 332, 
      responderNo: 984000003224257, 
      lifeNo: 5581019270, 
      lastDetected: 1, 
      locationId: 1,
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 4, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Duroc, 
      milestoneId: 2, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    {
      animalId: 6557, 
      pen: 333, 
      responderNo: 984000003224258, 
      lifeNo: 5581019271, 
      lastDetected: 2, 
      locationId: 1,
      remainingToday: 4, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 2, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 3, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    {
      animalId: 7668, 
      pen: 334, 
      responderNo: 984000003224259, 
      lifeNo: 5581019272, 
      lastDetected: 3, 
      locationId: 1,
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 4, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    {
      animalId: 8779, 
      pen: 335, 
      responderNo: 984000003224260, 
      lifeNo: 5581019273, 
      lastDetected: 4, 
      locationId: 1,
      remainingToday: 2, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 4, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 5, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    {
      animalId: 9880, 
      pen: 336, 
      responderNo: 984000003224261, 
      lifeNo: 5581019274, 
      lastDetected: 5, 
      locationId: 1,
      remainingToday: 1, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 1,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 1, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    {
      animalId: 1991, 
      pen: 337, 
      responderNo: 984000003224262, 
      lifeNo: 5581019275, 
      lastDetected: 6, 
      locationId: 1,
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 2, 
      feedPlan: 1, 
      groupId: 1, 
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 2, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    {
      animalId: 3112, 
      pen: 338, 
      responderNo: 984000003224263, 
      lifeNo: 5581019276, 
      lastDetected: 7, 
      locationId: 1,
      remainingToday: 2, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 3, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    {
      animalId: 4223, 
      pen: 339, 
      responderNo: 984000003224264, 
      lifeNo: 5581019277, 
      lastDetected: 8, 
      locationId: 1,
      remainingToday: 4, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 4, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 4, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    {
      animalId: 5334, 
      pen: 340, 
      responderNo: 984000003224265, 
      lifeNo: 5581019278, 
      lastDetected: 9, 
      locationId: 1,
      remainingToday: 1, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 5, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    {
      animalId: 6445, 
      pen: 341, 
      responderNo: 984000003224266, 
      lifeNo: 5581019279, 
      lastDetected: 1, 
      locationId: 1,
      remainingToday: 2, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 2, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 1, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    {
      animalId: 7556, 
      pen: 342, 
      responderNo: 984000003224267, 
      lifeNo: 5581019280, 
      lastDetected: 2, 
      locationId: 1,
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 2, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    {
      animalId: 8667, 
      pen: 343, 
      responderNo: 984000003224268, 
      lifeNo: 5581019281, 
      lastDetected: 3, 
      locationId: 1,
      remainingToday: 4, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 4, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 3, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    {
      animalId: 9778, 
      pen: 344, 
      responderNo: 984000003224269, 
      lifeNo: 5581019282, 
      lastDetected: 4, 
      locationId: 1,
      remainingToday: 1, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 2, 
      groupId: 1,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 4, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    {
      animalId: 1889, 
      pen: 345, 
      responderNo: 984000003224270, 
      lifeNo: 5581019283, 
      lastDetected: 5, 
      locationId: 1,
      remainingToday: 2, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 2, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 5, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    {
      animalId: 2990, 
      pen: 346, 
      responderNo: 984000003224271, 
      lifeNo: 5581019284, 
      lastDetected: 6, 
      locationId: 1,
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 1, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    {
      animalId: 3111, 
      pen: 347, 
      responderNo: 984000003224272, 
      lifeNo: 5581019285, 
      lastDetected: 7, 
      locationId: 2,
      remainingToday: 4, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 2, 
      feedPlan: 1, 
      groupId: 3,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 2, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    },
    {
      animalId: 4222, 
      pen: 348, 
      responderNo: 984000003224273, 
      lifeNo: 5581019286, 
      lastDetected: 8, 
      locationId: 1, 
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 1,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 3, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    }  ,{
      animalId: 5001, 
      pen: 348, 
      responderNo: 984000003224273, 
      lifeNo: 5581019286, 
      lastDetected: 8, 
      locationId: 1, 
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 2,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 4, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    }   ,{
      animalId: 5002, 
      pen: 348, 
      responderNo: 984000003224273, 
      lifeNo: 5581019286, 
      lastDetected: 8, 
      locationId: 1, 
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 2,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 5, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    }   ,{
      animalId: 5003, 
      pen: 348, 
      responderNo: 984000003224273, 
      lifeNo: 5581019286, 
      lastDetected: 8, 
      locationId: 1, 
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 2,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 1, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    }   ,{
      animalId: 5004, 
      pen: 348, 
      responderNo: 984000003224273, 
      lifeNo: 5581019286, 
      lastDetected: 8, 
      locationId: 1, 
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 2,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 2, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    }   ,{
      animalId: 5005, 
      pen: 348, 
      responderNo: 984000003224273, 
      lifeNo: 5581019286, 
      lastDetected: 8, 
      locationId: 1, 
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 2,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 3, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    }   ,{
      animalId: 5006, 
      pen: 348, 
      responderNo: 984000003224273, 
      lifeNo: 5581019286, 
      lastDetected: 8, 
      locationId: 1, 
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 1, 
      feedPlan: 1, 
      groupId: 2,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 4, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    }   ,{
      animalId: 5007, 
      pen: 348, 
      responderNo: 984000003224273, 
      lifeNo: 5581019286, 
      lastDetected: 8, 
      locationId: 1, 
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 2, 
      feedPlan: 1, 
      groupId: 2,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 5, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    }   ,{
      animalId: 5008, 
      pen: 348, 
      responderNo: 984000003224273, 
      lifeNo: 5581019286, 
      lastDetected: 8, 
      locationId: 1, 
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 2, 
      feedPlan: 1, 
      groupId: 2,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 1, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    }   ,{
      animalId: 5009, 
      pen: 348, 
      responderNo: 984000003224273, 
      lifeNo: 5581019286, 
      lastDetected: 8, 
      locationId: 1, 
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 3, 
      feedPlan: 1, 
      groupId: 3,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 2, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    }   ,{
      animalId: 5010, 
      pen: 348, 
      responderNo: 984000003224273, 
      lifeNo: 5581019286, 
      lastDetected: 8, 
      locationId: 1, 
      remainingToday: 3, 
      remainingYesterday: 4, 
      totalFood: 5, 
      conditionId: 5, 
      feedPlan: 1, 
      groupId: 3,
      animalType: AnimalTypes.Yorkshire, 
      milestoneId: 3, 
      milestoneDay: new Date('2025-01-26'), 
      cycleDayTotal: 50 
    }  
  ]

  export const getAnimalDatas = ():Animals[] => {
    var data = JSON.stringify(TestData)
    return JSON.parse(data);
  }

  export const myChosenFilters = [
    {filtersId: 1, filterName: "Farrowing Unit Fat Very Fat", conditions:[{conditionId: 4}, {conditionId: 5}], locations: [{locationId: 1}]},
    {filtersId: 2, filterName: "Insemination Skinny", conditions:[{conditionId: 2}], milestones:[{milestoneId: 1}]}
  ]